import React from 'react';
import StatsTile from './StatsTile';
import ChangeTile from './ChangeTile';
import { PropTypes } from 'prop-types';
import { I18n } from 'react-redux-i18n-lite';
import dayjs from 'dayjs';

export class TableContainerRow extends React.Component {
  static propTypes = {
    rowData: PropTypes.object,
    isXsScreen: PropTypes.any,
    weekNumber: PropTypes.number
  };

  renderWeekNumberTile(weekName) {
    let { rowData } = this.props;
    let startDate = dayjs(rowData.start).format('D');
    let endDate = dayjs(rowData.end).format('D MMMM');

    return (
      <div className="week-number-tile">
        <span>{weekName}</span>
        <span>{`${startDate} - ${endDate}`}</span>
      </div>
    );
  }

  renderStatsTiles() {
    let { rowData } = this.props;
    let statsTiles = [];
    for (let dayNumber = 0; dayNumber < 6; dayNumber++) {
      statsTiles.push(<StatsTile stats={undefined} key={`emptyTile + ${dayNumber}`} />);
    }

    rowData.days.map((day, index) => {
      let dayNumber = dayjs(day.date).isoWeekday() - 1;
      if (dayNumber === 6) {
        dayNumber = 5;
      }
      return (statsTiles[dayNumber] = <StatsTile stats={day.average} key={`statsTile + ${index}`} />);
    });

    statsTiles.push(<ChangeTile stats={rowData.performance} key={'changeTile' + statsTiles.length} />);
    return statsTiles;
  }

  render() {
    let { isXsScreen, weekNumber } = this.props;
    let weekName = `${I18n.t('panels.time.week').toUpperCase()} ${weekNumber}`;
    if (isXsScreen) {
      weekName = `${weekName[0]}${weekNumber}`;
    }
    return (
      <div className="basic-analytics-tiles-row-container">
        {this.renderWeekNumberTile(weekName)}
        {this.renderStatsTiles()}
      </div>
    );
  }
}

export default TableContainerRow;
